import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field_show_downloads_page', () => {
  import('./internal/map').then(({ default: Component }) => Component());
});
